// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteEngagementWrapper__y_c6n {
  min-height: 100%;
  background: var(--tables-main-surface);
}

.siteEngagementBody__NI9Ti {
  padding: 25px 25px 0px 25px;
  height: calc(100vh - 140px);
  overflow-y: auto;
}
.siteEngagementBody__NI9Ti::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.siteEngagementBody__NI9Ti::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.siteEngagementBody__NI9Ti::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.siteEngagementBody__NI9Ti::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 900px) {
  .siteEngagementBody__NI9Ti {
    padding: 15px 15px 0px 15px;
    height: calc(100vh - 120px);
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/SiteEngagement/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,gBAAA;EACA,sCAAA;AA3EF;;AA8EA;EACE,2BAAA;EACA,2BAAA;EACA,gBAAA;AA3EF;AAiBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,+BAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,8BAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,kBAAA;AAlBJ;AA6DE;EANF;IAOI,2BAAA;IACA,2BAAA;EA1DF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.siteEngagementWrapper {\n  min-height: 100%;\n  background: var(--tables-main-surface);\n}\n\n.siteEngagementBody {\n  padding: 25px 25px 0px 25px;\n  height: calc(100vh - 140px);\n  overflow-y: auto;\n  @include scrollBar;\n\n  @media (max-width: 900px) {\n    padding: 15px 15px 0px 15px;\n    height: calc(100vh - 120px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteEngagementWrapper": `siteEngagementWrapper__y_c6n`,
	"siteEngagementBody": `siteEngagementBody__NI9Ti`
};
module.exports = ___CSS_LOADER_EXPORT___;
